module.exports = __webpack_public_path__ + "static/media/invue-live-logo.74951cd0.svg";